<template>
  <div class="pl-4">
    <v-list-item>
      <filter-menu include-reset @reset="status='2';load()" no-hint>
        <v-list-item>
          <date-range :from.sync="from" :to.sync="to" v-model="dateDisplay" @change="load()"/>
        </v-list-item>
        <v-list-item>
          <v-autocomplete label="Status" dense outlined :items="[{value:'2',text:'All'},{divider:true},{value:'1',text:'Success'},{value:'0',text:'Error'}]" v-model="status"/>
        </v-list-item>
      </filter-menu>
      <div class="text-caption mr-1">{{dateDisplay}}</div>
      <template v-if="!$vuetify.breakpoint.mobile">
        <v-chip v-show="status!='2'" close small class="ml-1" @click:close="status='2'">{{status=='1'?'Success':'Error'}}</v-chip>
      </template>
      <v-spacer/>
      <v-btn icon @click="graphShow()"><v-icon>mdi-chart-line</v-icon></v-btn>
      <v-dialog v-model="showGraph" width="496">
        <component :is="graph" zoomed @close="showGraph=false" disableTo/>
      </v-dialog>
      <v-btn small text @click="showConfirm=true">Clear log</v-btn>
    </v-list-item>

    <v-data-table fixed-header height="calc(100vh - 212px)" class="purtrak-table"
                  calculate-widths disable-filtering
                  :footerProps="{showFirstLastPage:true, itemsPerPageOptions:[25,50,100,-1]}"
                  :items="logFiltered"
                  :headers="[{text:'Date',value:'date',width:'20%'},
                            {text:'Status',value:'status',width:'20%',align:'center',sortable:false},
                            {text:'Method',value:'method',width:'20%',sortable:true},
                            {text:'Order date',value:'created',width:'20%'},
                            {text:'Total',value:'amount',width:'20%',align:'right'}]">
      <template v-slot:item.date="{value}">
        {{value | formatDateTime}}
      </template>
      <template v-slot:item.method="{value}">
        {{value === 'RealTime' ? 'Real time' : value}}
      </template>
      <template v-slot:item.status="{item}">
        <v-menu v-if="item.error" open-on-hover offset-y>
          <template v-slot:activator="{ on }">
            <v-chip v-on="on" color="error" small>Error</v-chip>
          </template>
          <v-card flat class="pa-4 error--text">{{item.error}}</v-card>
        </v-menu>
        <v-chip color="success" small v-else :to="{name:'SalesShipmentsEdit',params:{shipmentId:item.shipmentId}}">{{item.draft?'Draft ':''}}Shipment</v-chip>
      </template>
      <template v-slot:item.created="{value}">
        {{value | formatDateTime}}
      </template>
      <template v-slot:item.amount="{value}">
        {{value | currency}}
      </template>
    </v-data-table>

    <v-dialog v-model="showConfirm" persistent max-width="400">
      <v-card>
        <v-card-title>Clear log</v-card-title>
        <v-divider/>
        <v-card-text class="pt-4">
          Are you sure you want to <strong>permanently</strong> clear the log?
        </v-card-text>
        <v-divider/>
        <v-card-actions class="pr-6">
          <v-spacer></v-spacer>
          <v-btn color="error" plain @click="clearLog()">Clear log</v-btn>
          <v-btn color="primary" @click="showConfirm=false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import googleCharts from '@/mixins/googleCharts'

export default {
  name: 'AppsSquareLog',
  mixins: [googleCharts],
  data() {
    return {
      graph: null,
      showGraph: false,
      from: null,
      to: null,
      status: '2',
      dateDisplay: '',
      log: [],
      showConfirm: false
    }
  },
  computed: {
    logFiltered() {
      if (this.status === '2')
        return this.log;
      return this.log.filter(log => this.status === '0' && log.error || this.status === '1' && !log.error);
    }
  },
  methods: {
    async load() {
      const results = await this.$apiCall(`query AppsSquareLog($from:Date!,$to:Date!) {
                                              squareLog(from:$from, to:$to) {
                                                date,shipmentId,created,amount,error,method,draft
                                              }
                                            }`,
                                            {from:this.from,to:this.to}, false, 'square');
      if (!results.error)
        this.log = results.data.squareLog;
    },
    async graphShow() {
      await this.loadGoogleCharts();
      this.graph = () => import(`@/views/dashboard/DashboardSquare`);
      this.showGraph = true;
    },
    async clearLog() {
      const results = await this.$apiCall(`mutation AppsSquareLog {squareClearLog}`, {}, false, 'square');
      if (!results.error) {
        this.log = [];
        this.showConfirm = false;
      }
    }
  }
}
</script>
